import initMobileNav from "/lib/mobile-nav";
import initA11yFunctions from "/lib/accessibility";
import initMainNav from "/lib/main-nav";

initMobileNav();
initA11yFunctions();
initMainNav();
